import React, { useState, useContext } from 'react';
import './Header.css';
import Logo from '../assets/logo-brik.png';
import { CartContext } from '../context/CartContext';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { cart } = useContext(CartContext);

  // Calculate the total number of items in the cart
  const totalItems = cart.reduce((total, item) => total + item.quantity, 0);

  const toggleMenu = () => {
    setMenuOpen(prev => !prev);
  };

  return (
    <header className="header">
      <div className="header-logo">
        <a href="/">
          <img src={Logo} alt="The Brik Logo" />
        </a>
      </div>
      <nav className={`header-nav ${menuOpen ? 'open' : ''}`}>
        <ul className="header-icons">
          <li>
            <a href="/">
              <i className="fas fa-home"></i> <span>Home</span>
            </a>
          </li>
          <li>
            <a href="/shop">
              <i className="fas fa-store"></i> <span>Shop</span>
            </a>
          </li>
          <li>
            <a href="/cart">
              <i className="fas fa-shopping-cart"></i> <span>Cart</span>
              {totalItems > 0 && (
                <span className="cart-count">{totalItems}</span>
              )}
            </a>
          </li>
          <li>
            <a href="/track">
              <i className="fas fa-shipping-fast"></i> <span>Track</span>
            </a>
          </li>
        </ul>
      </nav>
      <div className="hamburger" onClick={toggleMenu}>
        <i className="fas fa-bars"></i>
      </div>
    </header>
  );
};

export default Header;
